
import API from '@/api'

const actions = {
  getTour({ dispatch, commit, getters }, { id, query }) {
    API.tours.getTour(query)
      .then(({ data: { data } }) => {
        const {
          placeId,
          checkInDate,
          duration,
          rooms,
          currency
        } = query

        data.hotels.forEach((hotel, hotelIndex) => {
          const {
            hotelId,
            searchId,
            results,
            filters
          } = hotel

          dispatch('getHotel', {
            id: hotelId,
            query: {
              placeId,
              checkInDate,
              duration,
              rooms,
              currency
            },
            hotelIndex
          })

          commit('setHotelAccommodations', {
            searchId,
            results,
            filters,
            hotelIndex
          })
        })

        data.flights.forEach((flight, flightIndex) => {
          commit('setFlightInitial')
          const {
            searchId,
            results
          } = flight

          commit('setFlights', {
            searchId,
            results,
            flightIndex
          })

          commit('updateFlightCurrent', {
            aviaticketId: results[0].id,
            flightIndex
          })
        })

        data.visas.forEach((visa, visaIndex) => {
          commit('setVisaInitial')
          const {
            cities,
            results
          } = visa

          commit('setVisaCities', {
            visaIndex,
            cities
          })

          commit('setToursVisas', {
            visaIndex,
            visa
          })

          Array(getters.getNumberOfTourists.total).fill(null)
            .forEach((x, touristIndex) => {
              commit('updateServiceField', {
                target: `visas.${visaIndex}.form.cityId`,
                value: [
                  ...getters.getServiceField(`visas.${visaIndex}.form.cityId`),
                  cities[0].slug
                ]
              })

              const resultsInCity = results.find(item => item.citySlug === cities[0].slug).results

              commit('setVisaVisas', {
                touristIndex,
                visaIndex,
                data: {
                  ...getters.getToursVisasIds(visaIndex),
                  results: resultsInCity
                }
              })

              commit('updateServiceField', {
                target: `visas.${visaIndex}.visas.selected`,
                value: [
                  ...getters.getVisa(visaIndex).selected,
                  resultsInCity[0].id
                ]
              })
            })
        })

        data.insurances.forEach((insurance, insuranceIndex) => {
          commit('setInsuranceInitial')
          const {
            searchId,
            results
          } = insurance

          commit('setInsurances', {
            insuranceIndex,
            data: {
              searchId,
              results
            }
          })

          commit('updateInsuranceCurrent', {
            target: insuranceIndex,
            value: results[0].id
          })
        })

        data.transfers.forEach((transfer, transferIndex) => {
          commit('setTransferInitial')
          const {
            searchId,
            placeFrom,
            cityFrom,
            placeTo,
            cityTo,
            results,
            date
          } = transfer

          commit('setTransfers', {
            transferIndex,
            searchId,
            results
          })

          commit('setTransferPlaces', {
            transferIndex,
            placeFrom,
            cityFrom,
            placeTo,
            cityTo
          })

          commit('setTransferStartDate', {
            transferIndex,
            date
          })

          commit('updateTransfersCurrent', {
            target: `transfers.${transferIndex}.transfers.current`,
            value: results[0].vehicleId
          })
        })
      })
      .catch(errors => console.log(errors))
  },
  async getTourAccommodations({ commit }, { hotelIndex, params }) {
    await API.tours.getAccommodations(params)
      .then(({ data: { data: { searchId, results, filters } } }) => {
        commit('setHotelAccommodations', {
          searchId,
          results,
          filters,
          hotelIndex
        })
      })
      .catch(errors => console.log(errors))
  },
  async getTourTransfers({ commit }, params) {
    commit('clearTransfersState')

    await API.tours.getTransfers(params)
      .then(({ data: { data } }) => {
        data.results.forEach((transfer, transferIndex) => {
          commit('setTransferInitial')
          const {
            searchId,
            placeFrom,
            cityFrom,
            placeTo,
            cityTo,
            results,
            date
          } = transfer

          commit('setTransfers', {
            transferIndex,
            searchId,
            results
          })

          commit('setTransferPlaces', {
            transferIndex,
            placeFrom,
            cityFrom,
            placeTo,
            cityTo
          })

          commit('setTransferStartDate', {
            transferIndex,
            date
          })

          commit('updateTransfersCurrent', {
            target: `transfers.${transferIndex}.transfers.current`,
            value: results[0].vehicleId
          })
        })
      })
      .catch(errors => console.log(errors))
  },
  getTourFlights({ commit }, params) {
    API.tours.getFlights(params)
      .then(({ data: { data } }) => {
        console.log(data)
      })
      .catch(errors => console.log(errors))
  },
}

export default actions